import receptionRoute from "@/app/router/routes/ReceptionRoute";
import PsychologyConsultationRoute from "./routes/PsychologyConsultationRoute";
import PsychologyHistorialRoute from "./routes/PsychologyHistorialRoute";
import ChangeControlRoute from "./routes/ChangeControlRoute";
import DentalConsultationRoute from "./routes/DentalConsultationRoute";
import DentalHistoryRoute from "./routes/DentalHistoryRoute";
import MastographyFindingRoute from "./routes/MastographyFindingRoute";
import InterpretationPendingRoute from "./routes/InterpretationPendingRoute";
import InterpretationValidateRoute from "./routes/InterpretationValidateRoute";
import InterpretationRevalidationPending from "./routes/InterpretationRevalidationPending";
import InterpretationRevalidationHistory from "./routes/InterpretationRevalidationHistory";
import InterpretationHistoryRoute from "./routes/InterpretationHistoryRoute";
import camujalRoute from "./routes/camujalRoute";
import WebServicesRoute from "./routes/WebServicesRoute";
import OptometryPendingRoute from "./routes/OptometryPendingRoute";
import OptometryHistoryRoute from "./routes/OptometryHistoryRoute";
import AudiometryHistoryRoute from "./routes/AudiometryHistoryRoute";
import AudiometryPedingRoute from "./routes/AudiometryPendingRoute";
import TemplateDialogRoute from "./routes/TemplateDialogRoute";
import DownloadStudieRoute from "./routes/DownloadStudieRoute";
import HistoryStudiesRoute from "./routes/HistoryStudiesRoute";
import ScreenTurnRoute from "./routes/ScreenTurnRoute";
import ProductsRoute from "./routes/ProductsRoute";
import LogsRoute from "./routes/LogsRoute";
import SyncRoute from "./routes/SyncRoute";
import PhysicalSpacesRoute from "./routes/PhysicalSpacesRoute";
import DoctorRoute from "./routes/DoctorRoute";
import ImageHistoryRoute from "./routes/ImageHistoryRoute";
import ColposcopyPendingRoute from "./routes/ColposcopyPendingRoute";
import ColposcopyHistoryRoute from "./routes/ColposcopyHistoryRoute";
import TelemedicinePendingRoute from "./routes/TelemedicinePendingRoute";
import TelemedicineToStartTable from "./routes/TelemedicineToStartRoute";
import TelemedicineHistoryTable from "./routes/TelemedicineHistoryRoute";




const routes = [
  receptionRoute,
  PsychologyConsultationRoute,
  PsychologyHistorialRoute,
  ChangeControlRoute,
  DentalConsultationRoute,
  DentalHistoryRoute,
  MastographyFindingRoute,
  InterpretationPendingRoute,
  InterpretationValidateRoute,
  InterpretationHistoryRoute,
  InterpretationRevalidationPending,
  InterpretationRevalidationHistory,
  camujalRoute,
  WebServicesRoute,
  OptometryPendingRoute,
  OptometryHistoryRoute,
  AudiometryHistoryRoute,
  AudiometryPedingRoute,
  TemplateDialogRoute,
  DownloadStudieRoute,
  HistoryStudiesRoute,
  ScreenTurnRoute,
  ProductsRoute,
  LogsRoute,
  SyncRoute,
  PhysicalSpacesRoute,
  DoctorRoute,
  ImageHistoryRoute,
  ColposcopyPendingRoute,
  ColposcopyHistoryRoute,
  TelemedicinePendingRoute,
  TelemedicineToStartTable,
  TelemedicineHistoryTable
];

export default routes;
